import store from "@redux/store";
import { COUNTRY, COUNTRY_CONFIG } from "@type/index";

export const footAndInches: COUNTRY_CONFIG<boolean> = {
  jp: false,
  us: true,
  uk: true,
  fr: false,
  de: false,
  es: false,
  it: false,
  dk: false,
  se: false,
  nl: false,
  be: false,
  fi: false,
  gr: false,
  ie: false,
  lu: false,
  at: false,
  pl: false,
  pt: false,
  si: false,
  sk: false,
  lt: false,
  lv: false,
  ee: false,
  cz: false,
  hu: false,
  ro: false,
  bg: false,
  hr: false,
  ca: false
};

// inch conversion
export const heightFootFromTotalInch = (totalInch: number) =>
  Math.floor(totalInch / 12);
export const heightInchFromTotalInch = (totalInch: number) =>
  Math.floor(totalInch % 12);
export const heightFootInchFromTotalInch = (totalInch: number) => {
  const foot = heightFootFromTotalInch(totalInch);
  const inch = heightInchFromTotalInch(totalInch);
  return `${foot}′ ${inch}″`;
};

export const userHeight = (height: number): string => {
  const config = store.getState().config;
  const country = config.region as COUNTRY;
  if (footAndInches[country])
    return height === 0 ? "-′-″" : heightFootInchFromTotalInch(height);
  else return height === 0 ? "-" : height?.toString() ?? "-";
};
